import css from 'styled-jsx/css';

const staticStyles = css`
  .RejectModal__content {
    max-width: 430px;
  }
`;

export default staticStyles;
